export const buildQueryParams = (params, queryParams = new URLSearchParams()) => {
  Object.keys(params).forEach(key => {
    if (params[key] === undefined || params[key] === null) {
      return;
    }

    queryParams.append(key, params[key]);
  });

  return queryParams;
};
